"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var merchant = _interopRequireWildcard(require("@/api/merchant"));
var _permission = require("@/utils/permission");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  data: function data() {
    return {
      tableFrom: {},
      tableData: {
        data: [],
        total: 0
      },
      listLoading: false,
      dialogVisible: false,
      dialogTitle: '添加店铺类型',
      submitLoading: false,
      id: 0,
      dataForm: {
        name: '',
        info: '',
        icon: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入店铺类型名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:merchant:type:all'])) this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // Fix duplicated domain in icon URL
    fixIconUrl: function fixIconUrl(url) {
      if (!url) return '';
      var domain = 'https://henuo.oss-cn-hongkong.aliyuncs.com/';
      if (url.startsWith(domain + 'http')) {
        return url.replace(domain, '');
      }
      return url;
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      merchant.merchantTypeListApi().then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
        _this2.$message.error(res.message);
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    handlerOpenEdit: function handlerOpenEdit(isCreate, editData) {
      this.id = editData ? editData.id : 0;
      this.dialogTitle = isCreate === 0 ? '添加店铺类型' : '编辑店铺类型';
      this.dataForm = {
        name: editData ? editData.name : '',
        info: editData ? editData.info : '',
        icon: editData ? editData.icon || '' : ''
      };
      this.dialogVisible = true;
    },
    handleDialogClose: function handleDialogClose() {
      this.dialogVisible = false;
      this.$refs.dataForm && this.$refs.dataForm.resetFields();
    },
    modalPicTap: function modalPicTap() {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img || !img.length) return;
        _this.dataForm.icon = img[0].sattDir;
      }, false, 'store');
    },
    handleRemoveIcon: function handleRemoveIcon() {
      this.dataForm.icon = '';
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this3.submitLoading = true;
        // Remove all domain prefixes, only send relative path
        var iconPath = _this3.dataForm.icon || '';
        var domain = 'https://henuo.oss-cn-hongkong.aliyuncs.com/';
        while (iconPath.includes(domain)) {
          iconPath = iconPath.replace(domain, '');
        }
        var data = {
          id: _this3.id,
          name: _this3.dataForm.name,
          info: _this3.dataForm.info,
          icon: iconPath
        };
        var apiMethod = _this3.id ? merchant.merchantTypeUpdateApi : merchant.merchantTypeAddApi;
        apiMethod(data).then(function () {
          _this3.$message.success('操作成功');
          _this3.dialogVisible = false;
          _this3.$store.commit('merchant/SET_MerchantType', []);
          _this3.getList();
        }).finally(function () {
          _this3.submitLoading = false;
        });
      });
    },
    handlerOpenDel: function handlerOpenDel(rowData) {
      var _this4 = this;
      this.$modalSure('删除当前店铺类型吗？').then(function () {
        merchant.merchantTypeDeleteApi(rowData.id).then(function () {
          _this4.$message.success('删除店铺类型成功');
          _this4.getList();
          _this4.$store.commit('merchant/SET_MerchantType', []);
        });
      });
    }
  }
};